import { FC } from 'react'
import { Helmet } from 'react-helmet-async'

import { ISeoProps } from './types'

const Seo: FC<ISeoProps> = ({ title, description, name, type }) => (
  <Helmet>
    {title && <title>{title}</title>}
    {description && <meta content={description} name="description" />}

    {type && <meta content={type} property="og:type" />}
    {title && <meta content={title} property="og:title" />}
    {description && <meta content={description} property="og:description" />}

    {name && <meta content={name} name="twitter:creator" />}
    {type && <meta content={type} name="twitter:card" />}
    {title && <meta content={title} name="twitter:title" />}
    {description && <meta content={description} name="twitter:description" />}
  </Helmet>
)

export default Seo
